import { useMemo } from "react";
import { PrefetchLink } from "@boundary/components/prefetchLink";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import { useOrders } from "@boundary/_hooks/useOrders";
import { OrderHistoryListItem } from "@domain/dtos/models/order.models";
import styles from "./activeOrdersCarousel.module.scss";

function formatReadyTime(order: OrderHistoryListItem): string {
  if (order.status === "ready" || order.status === "issued" || order.status === "processing_finished") {
    return order.status_description || "Готов к выдаче";
  }
  
  if (order.time_to_ready) {
    const minutes = parseInt(order.time_to_ready, 10);
    if (minutes === 0) {
      return "Будет готов скоро";
    }
    return `Будет готов через ${minutes} мин`;
  }
  
  return order.status_description || order.status;
}


// Карусель активных заказов на карте
export function ActiveOrdersCarousel() {
  const { activeOrders } = useOrders();
  const hasActiveOrders = activeOrders && activeOrders.length > 0;

  const sortedActiveOrders = useMemo(() => {
    if (!activeOrders) return [];
    return [...activeOrders].sort((a, b) => {
      return b.order_number.localeCompare(a.order_number);
    });
  }, [activeOrders]);

  if (!hasActiveOrders) {
    return null;
  }

  return (
    <div className={styles.container}>
      <Swiper 
        className={styles.swiper}
        modules={[Pagination]}
        pagination={{ clickable: true }}
        spaceBetween={12}
        slidesPerView={1}
      >
        {sortedActiveOrders.map((order) => (
          <SwiperSlide key={order.order_number} className={styles.slide}>
            <PrefetchLink to={`/order/${order.order_number}`} className={styles.card}>
              <div className={styles.cardContent}>
                <div className={styles.cardTitle}>
                  Заказ {order.order_number}
                </div>
                <div className={styles.cardStatus}>
                  {formatReadyTime(order)}
                </div>
              </div>
              <img
                src="/assets/printerSm.png"
                alt=""
                className={styles.cardIcon}
                loading="lazy"
              />
            </PrefetchLink>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
